var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "loader": _vm.loader
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (3),
      expression: "3",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.product.name) + "\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "3"
    }
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [(_vm.isManual) ? _c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                        Готовность от 15-ти минут до 4-х часов "), _c('br'), _vm._v("\n                        Понедельник — Пятница "), _c('br'), _vm._v(" 7:00 — 18:00 (мск) "), _c('br'), _vm._v("\n                        Суббота, Воскресенье выходные\n                    ")]) : _c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                        Готовность в режиме онлайн, круглосуточно\n                    ")])], 1), _vm._v(" "), _vm._l((_vm.product.links), function(link, key) {
    return _c('div', {
      key: key
    }, [_c('v-link', {
      attrs: {
        "to": link,
        "target": "_blank"
      }
    }, [_vm._v("\n                        Пример отчета " + _vm._s(_vm.product.links.length > 1 ? key + 1 : '') + "\n                    ")])], 1)
  })], 2), _vm._v(" "), _c('v-col', [_c('div', {
    class: _vm.theme.exampleDescription,
    domProps: {
      "innerHTML": _vm._s(_vm.product.fullDescription)
    }
  })])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a28326","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/reportExample/ReportExample.vue
// module id = 1132
// module chunks = 0